export interface Pagination {
  total: number
  page: number
  limit: number
  next_cursor: string | null
}

export const enum ErrorCode {
  'INTERNAL_ERROR'= "INTERNAL_ERROR",
  'VALIDATION_ERROR'= "VALIDATION_ERROR",
  'INVALID_ORDER'= "INVALID_ORDER",
  'BAD_REQUEST'= "BAD_REQUEST",
  'CONFLICT'= "CONFLICT",
  'NOT_FOUND'= "NOT_FOUND",
  'FORBIDDEN'= "FORBIDDEN",
  'ANAUTHORIZED'= "ANAUTHORIZED",
  'USER_NOT_FOUND'= "USER_NOT_FOUND",
  'ORDER_NOT_FOUND'= "ORDER_NOT_FOUND",
  'POSITION_NOT_FOUND'= "POSITION_NOT_FOUND",
  'INSTRUMENT_NOT_FOUND'= "INSTRUMENT_NOT_FOUND",
  'UNAUTHORIZED'= "UNAUTHORIZED",
  'INVALID_CREDENTIALS'= "INVALID_CREDENTIALS",
  'INVALID_TOKEN'= "INVALID_TOKEN",
  'INSUFFICIENT_PERMISSIONS'= "INSUFFICIENT_PERMISSIONS",
  'INSUFFICIENT_BALANCE'= "INSUFFICIENT_BALANCE",
  'INSUFFICIENT_MARGIN'= "INSUFFICIENT_MARGIN",
  'ORDER_REJECTED'= "ORDER_REJECTED",
  'POSITION_LIMIT_EXCEEDED'= "POSITION_LIMIT_EXCEEDED",
  'TRADING_DISABLED'= "TRADING_DISABLED",
  'MARGIN_CALL'= "MARGIN_CALL",
  'LIQUIDATION'= "LIQUIDATION",
  'SERVICE_UNAVAILABLE'= "SERVICE_UNAVAILABLE",
  'RATE_LIMIT_EXCEEDED'= "RATE_LIMIT_EXCEEDED",
  'DATABASE_ERROR'= "DATABASE_ERROR",
  'CONNECTION_ERROR'= "CONNECTION_ERROR",

  'AXIOS_CONFIG_ERROR'= "AXIOS_CONFIG_ERROR",
  'NOT_SUPPORTED'= "NOT_SUPPORTED",
  'DEPRECATED'= "DEPRECATED",
  'INVALID_URL'= "INVALID_URL",
  'TIMEOUT'= "TIMEOUT",
  'CANCELLED'= "CANCELLED",
  'NETWORK_ERROR'= "NETWORK_ERROR",
  'TOO_MANY_REDIRECTS'= "TOO_MANY_REDIRECTS",
  'BAD_RESPONSE'= "BAD_RESPONSE",
  'CLIENT_BAD_REQUEST'= "CLIENT_BAD_REQUEST",
}

export interface ApiError {
  code: ErrorCode;
  message: string;
  details?: Record<string, unknown> | null;
}

export type MultipleError = Record<string, ApiError>

export interface Error {
  message: string
}

export interface ResponseSuccess<T> {
  success: true;
  data: T;
  error: null;
  pagination?: Pagination | null;
}

export interface ResponseError {
  success: false;
  data: null;
  error: ApiError | Record<string, ApiError>;
  pagination?: Pagination | null;
}

export type MultipleErrorResponse = Omit<ResponseError, 'error'> & {
  error: MultipleError;
}

export type ApiResponse<T> = ResponseSuccess<T> | ResponseError;

export function isApiError(err: any): err is ApiError {
  return err && typeof err === 'object' && 'message' in err && 'code' in err;
}

export function isMultipleError(err: unknown): err is MultipleErrorResponse {
  if (!err
    || typeof err !== 'object'
    || 'success' in err && err.success !== false
    || !('error' in err)
    || typeof err.error !== 'object'
    || err.error === null) {
    return false;
  }

  if (Object.values(err.error).every(e => isApiError(e))) {
    return true;
  }

  return false;
}

export function isMultipleValidationError(err: unknown): err is MultipleErrorResponse {
  return isMultipleError(err)
    && Object.values(err.error)
      .every(e => e.code === ErrorCode.VALIDATION_ERROR);
}
